import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BehaviorSubject, from, interval, Observable} from 'rxjs';
import {ConfigsLoaderService} from './config-loader.service';
import {Notification} from 'app/models/notification.interface';
import {AuthService} from './auth.service';
import {filter, finalize, startWith, switchMap} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {

    private readonly useMockData = false;
    private readonly apiEndpoint: string;
    private notificationsSubject = new BehaviorSubject<Notification[]>([]);
    get notifications$() {
      return this.notificationsSubject.asObservable();
    }
    private refresh$ = new BehaviorSubject<void>(null);

    constructor(
        private httpClient: HttpClient,
        private config: ConfigsLoaderService,
        private authService: AuthService,
    ) {
        this.apiEndpoint = this.config.apiUrl;

        this.authService.currentUser$
          .pipe(
            switchMap(user => {
              // Cambiar 'notificationInterval' por variable de notificaciones (cuando este disponible)
              return interval(user?.['notificationInterval'] || (5 * 60 * 1000))
                .pipe(startWith(null)); // startWith - So that it doesn't wait the first interval
            }),
            switchMap(() => this.refresh$),
            switchMap(() => this.authService.isLoggedIn()),
            filter(isLoggedIn => isLoggedIn),
            switchMap(() => {
              return this.getNotifications();
            }),
          ).subscribe(this.notificationsSubject);

    }

    getNotifications(): Observable<Notification[]> {
      return from(this.authService.isLoggedInAndAuthorized())
      .pipe(
        switchMap(isLoggedIn => {
          if (isLoggedIn){
            return this.httpClient.get<Notification[]>(`${this.apiEndpoint}/Notification/GetAllByTop`);
          }
        })
      );
    }

    readNotificationById(id: number): Observable<any> {
        return this.httpClient.post(`${this.apiEndpoint}/Notification/ReadNotificationsById`, id)
          .pipe(
            finalize(() => this.refresh$.next(void 0)),
          );
    }

}
